import { Box } from "@mantine/core";
import { REPORT_IMAGE_ROLE } from "../../utils/reportImageAssets";

interface ReportLaboratoryLogoProps {
  source?: string | null;
}

export function ReportLaboratoryLogo({ source }: ReportLaboratoryLogoProps) {
  return (
    <Box style={{ flexShrink: 0 }}>
      {source ? (
        <img
          src={source}
          alt="Report laboratory logo"
          data-report-image-role={REPORT_IMAGE_ROLE.optionalBranding}
          style={{
            height: "82.38pt",
            width: "auto",
            maxWidth: "187.5pt",
            objectFit: "contain",
            display: "block",
          }}
        />
      ) : null}
    </Box>
  );
}
